module.exports = __webpack_public_path__ + "inst.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/inst.png
// module id = 536
// module chunks = 0